// export const API_HOST = 'http://localhost:3000';
// TODO: https
export const API_HOST = "https://api.pics.ericlondon.com";
